/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse,
  (requestParams: vp.PostELinxSettingsUpdateRequestRequest) => void,
  () => void,
  (requestParams: vp.PostELinxSettingsUpdateRequestRequest) => Promise<vp.ApiResponse>,
];

function usePostPaylinkSettingsUpdate({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.PostELinxSettingsUpdateRequestRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.PostELinxSettingsUpdateRequestRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postPaylinkSettingsUpdate(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.PostELinxSettingsUpdateRequestRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setSendRequest(false);
    },
    (requestParams: vp.PostELinxSettingsUpdateRequestRequest) => api.postPaylinkSettingsUpdate(requestParams, source),
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPaylinkSettingsUpdate);
